import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useSelector } from 'react-redux';
import MarkerPinIcon from '../../../../new-components/svg-icons/MarkerPinIcon';

const AreaIcon = () => {
  return (
    <AreaIconContainer>
      <MarkerPinIcon stroke="#fff" />
    </AreaIconContainer>
  );
};

const ResultCompoundImages = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );

  return (
    <Container>
      {firstDestination.image || firstDestination.image_path ? (
        <ImageWrapper
          src={firstDestination.image || firstDestination.image_path}
          alt="Compound Image"
          width={isMobile ? 35 : 55}
          height={isMobile ? 35 : 55}
          objectFit="cover"
          style={{ border: '2px solid #FFF', borderRadius: '360px' }}
        />
      ) : (
        <AreaIcon />
      )}
      {secondDestination.image || secondDestination.image_path ? (
        <ImageWrapper
          src={secondDestination.image || secondDestination.image_path}
          alt="Compound Image"
          width={isMobile ? 35 : 55}
          height={isMobile ? 35 : 55}
          objectFit="cover"
          style={{ border: '2px solid #FFF', borderRadius: '360px' }}
        />
      ) : (
        <AreaIcon />
      )}
    </Container>
  );
};

const AreaIconContainer = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #015c9a;
  border-radius: 360px;
  padding: 4px;
  border: 2px solid #fff;

  svg {
    width: 25px;
    height: 25px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div:first-child {
    margin-inline-end: -7px;
  }
  div:last-child {
    margin-inline-start: -7px;
  }

  img:first-child {
    margin-inline-end: -7px;
  }
  img:last-child {
    margin-inline-start: -7px;
  }
`;

export default ResultCompoundImages;
